module.exports = __webpack_public_path__ + "static/footer-banner-2bf6028ee2f64845867d26c824082a15.png";